<div *ngIf="!!customer" class="row">
  <div class="col-12 col-md-4">
    <h3 translate>CUSTOMER_INFORMATION</h3>
    <span class="d-block">{{ customer.extra.gme.address.name }}</span>
    <span class="d-block">{{ customer.extra.gme.address.address1 }}</span>
    <span class="d-block"
      >{{ customer.extra.gme.address.zipCode }} {{ customer.extra.gme.address.city }}</span
    >
    <span class="d-block">{{ customer.extra.gme.address.countryCode }}</span>
  </div>
  <div class="col-12 col-md-4">
    <h3 translate>BILLING_INFORMATION</h3>
    <span class="d-block">{{ customer.extra.gme.billingAddress.name }}</span>
    <span class="d-block">{{ customer.extra.gme.billingAddress.address1 }}</span>
    <span class="d-block"
      >{{ customer.extra.gme.billingAddress.zipCode }} {{ customer.extra.gme.billingAddress.city }}</span
    >
    <span class="d-block">{{ customer.extra.gme.billingAddress.countryCode }}</span>
  </div>
</div>

<div class="row mt-4">
  <h3 translate>DELIVERY_ADDRESSES</h3>
  <div class="col-12 table-responsive gung-responsive">
    <table class="table table-borderless table-striped">
      <thead>
        <tr>
          <th *ngIf="gungCustomerAddressService.enableFavouriteDeliveryAddresses"></th>
          <th translate>CODE</th>
          <th translate>NAME</th>
          <th translate>ADDRESS</th>
          <th translate>GLN</th>
          <th translate>ZIP</th>
          <th translate>COUNTRY_CODE</th>
          <th translate>PHONE</th>
          <th translate>EMAIL</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let address of sortedDeliveryAddresses">
          <td *ngIf="gungCustomerAddressService.enableFavouriteDeliveryAddresses">
            <span (click)="toggleFavourite(address)" style="cursor: pointer;">
              <i class="fa-star" 
                [ngClass]="{
                  'fa-solid': favouriteAddressIds.has(
                    address.address1 + address.address2 + address.city + address.countryCode + address.name + address.zipCode
                  ),
                  'fa-regular': !favouriteAddressIds.has(
                    address.address1 + address.address2 + address.city + address.countryCode + address.name + address.zipCode
                  )
                }"></i>
            </span>
          </td>
          <td [attr.data-label]="'CODE' | translate">
            {{ address.code }}
          </td>
          <td [attr.data-label]="'NAME' | translate">
            {{ address.name }}
          </td>
          <td [attr.data-label]="'ADDRESS' | translate">
            {{ address.address1 }}
          </td>
          <td [attr.data-label]="'GLN' | translate">
            {{ address.gln }}
          </td>
          <td [attr.data-label]="'ZIP' | translate">
            {{ address.zipCode }}
          </td>
          <td [attr.data-label]="'COUNTRY_CODE' | translate">
            {{ address.countryCode }}
          </td>
          <td [attr.data-label]="'PHONE' | translate">
            {{ address.phoneNo }}
          </td>
          <td [attr.data-label]="'EMAIL' | translate">
            {{ address.email }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
